import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBox: {
    height: 20,
    width: 90,
  },
});
